"use strict";
(self["webpackChunkshop_chunks"] = self["webpackChunkshop_chunks"] || []).push([[431],{

/***/ 6431:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ RevealAnimation)
/* harmony export */ });
/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9755);
/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(jquery__WEBPACK_IMPORTED_MODULE_0__);
    

/**
 * Watches for & triggers reveal animations when elements enter view
 */
function RevealAnimation({ wrapper }) {
  const $target = jquery__WEBPACK_IMPORTED_MODULE_0___default()(wrapper)   

  const activeClass   = 'tw-revealing',
        completeClass = 'tw-revealed'

  ;(function init() {
    initAnimationsObserver()   
  })()

  function initAnimationsObserver() {
    if ( typeof IntersectionObserver === 'function' ) {
      const options = {
        root: null,
        rootMargin: '0px',
        threshold: .05
      }   

      const observer = new IntersectionObserver((e) => observeAnimations(e), options)   
      observer.observe($target[0])   
    } 
    
    if ( typeof IntersectionObserver !== 'function' ) {
      triggerAnimation($target)   
    }
  }

  function observeAnimations(entries) {
    entries.forEach((entry) => {
      let $target = jquery__WEBPACK_IMPORTED_MODULE_0___default()(entry.target)   

      if ( !$target.hasClass(activeClass) && !$target.hasClass(completeClass) && entry.isIntersecting ) {
        const delay = screen.availWidth < 567 && $target.data('mobileDelay')
          ? $target.data('mobileDelay')
          : $target.data('delay')   

        triggerAnimation($target, delay)   
      }
    })   
  }

  function triggerAnimation($target, delay = 0) {
    setTimeout(() => {
      $target
        .addClass(activeClass)
        .one('animationend', () => {
          $target.toggleClass(`${ activeClass } ${ completeClass }`)   
        })   
    }, parseInt(delay))   
  }
}


/***/ })

}]);